
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/profile/[shopSysNo]",
      function () {
        return require("private-next-pages/shop/profile/[shopSysNo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/profile/[shopSysNo]"])
      });
    }
  